import request from '@/utils/request'
const apiPath = '/meet/meetingSignUp/teev2'
const areaMeetingExportApi = {
  /**
   * 参会人员导出【页面初始化信息】
   * 返回当前登录账号绑定的大区，以及可导出的会议列表
   */
  fetchInfo() {
    return request.get(`${apiPath}/areaExportInfo`)
  },
  /**
   * 导出【指定会议的参会人员】，仅含本大区管辖客户
   */
  exportExcel(query) {
    return request.get(`${apiPath}/exportForArea`, { params: query })
  }
}
export default areaMeetingExportApi
